import { render, staticRenderFns } from "./Kurtosis.vue?vue&type=template&id=769e41b9&scoped=true&"
var script = {}
import style0 from "./Kurtosis.vue?vue&type=style&index=0&id=769e41b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769e41b9",
  null
  
)

export default component.exports